import(/* webpackMode: "eager", webpackExports: ["FadeIn","StaggerContainer","StaggerItem","FadeInScale"] */ "/vercel/path0/components/motion/Animate.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/components/new-order/UnprotectedOrderWrapper.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/vercel/path0/node_modules/next/dist/client/app-dir/link.js");
